
import {Component, Prop} from 'vue-property-decorator'
import BaseForm from '@/components/forms/BaseForm'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import {required} from 'vuelidate/lib/validators'
import DocumentModel from '@/models/DocumentModel'
import convertDateDirective from '@/directives/convertDateDirective'
import {isCoprolibDate} from '@/helpers/validators'

@Component({
  components: {
    BaseFormContainer
  },
  directives: {
    convertDateDirective
  },
  validations: {
    form: {
      DATE_DOCUMENT: {
        required,
        isCoprolibDate
      }
    }
  }
})
export default class DocumentForm extends BaseForm {
  model = DocumentModel
}
